import React, { useState, useContext } from 'react'
import ModalComponent from 'Components/Modal/Modal.component'
import { Grid, Typography, Button } from '@material-ui/core'
import SendIcon from '@material-ui/icons/Send'
import { UserAccount } from 'types/UserProfile'
import ServicesContext from 'Contexts/Services/Services.context'
import { openSnackbar, SNACKBAR_GENERAL_ERROR_MESSAGE } from 'State/Store/Snackbar/SnackbarActionCreators'
import { useDispatch } from 'react-redux'
import { MFSDR } from 'Constants/MouseFlow/SensitiveDataReplacer'
import hitGTM from 'State/Store/UI/Actions/GTM.action'
import { UI_RESEND_INVITATION_ACCOUNT_PAGE_RESEND_DIALOG_SEND_BTN, UI_RESEND_INVITATION_ACCOUNT_PAGE_RESEND_DIALOG_CANCEL } from 'State/Store/UI/UI.types'
import cn from 'classnames'

interface Props {
  open: boolean,
  classes: any,
  onClose(): void,
  userAccount: null | UserAccount,
}

const ResendConfirmModal = (props: Props) => {
  const {
    open,
    classes,
    onClose,
    userAccount,
  } = props
  const [ loading, setLoading ] = useState(false)
  const services = useContext(ServicesContext)
  const dispatch = useDispatch()

  if (!userAccount) {
    return null
  }
  const handleClose = () => {
    dispatch(hitGTM(UI_RESEND_INVITATION_ACCOUNT_PAGE_RESEND_DIALOG_CANCEL))
    onClose()
  }

  const handleSend = async () => {
    dispatch(hitGTM(UI_RESEND_INVITATION_ACCOUNT_PAGE_RESEND_DIALOG_SEND_BTN))
    setLoading(true)
    try {
      const result = await services.userService.reactivate(userAccount)
      dispatch(openSnackbar({ message: `Invitation successfully sent.` }))
      onClose()
    } catch (e) {
      dispatch(openSnackbar({ message: SNACKBAR_GENERAL_ERROR_MESSAGE }))
    } finally {
      setLoading(false)
    }
  }
  return (
    <ModalComponent
      title={
        <Grid container>
          <Grid item xs={12}>
            {`Resend Invitation`}
          </Grid>
        </Grid>
      }
      content={
        <Grid container>
          <Grid item xs={12}>
            <Typography variant='body1'>
              <span>{`Are you sure you want to resend an invitation to `}</span>
              <span className={classes.fontWeight500} data-mf-replace-inner={MFSDR}>{userAccount.email}</span>
              <span>{` ?`}</span>
            </Typography>
            <Typography variant='body2' className={cn(classes.marginTop2unit, classes.opacity06)}>
              {`A link will be sent to the above email address. The user will be activated  after they click the link, set a password and complete their user profile. The link will expire 30 days after it is sent.`}
            </Typography>
          </Grid>
        </Grid>
      }
      footer={
        <Grid className={classes.textAlignRight} container justify='flex-end' spacing={2}>
          <Grid item>
            <Button
              className={classes.button}
              color='default'
              onClick={() => {
                handleClose()
              }}
              variant='contained'
            >
              {`Cancel`}
            </Button>
          </Grid>
          <Grid item>
            <Button
              disabled={loading}
              className={classes.button}
              color='primary'
              onClick={handleSend}
              variant='contained'
            >
              {`SEND INVITATION`}
            </Button>
          </Grid>
        </Grid>
      }
      paperScrollPaper={false}
      maxWidth='sm'
      icon={<SendIcon />}
      onClose={handleClose}
      open={open}
      rightHeading={null}

  />
  )
}

export default ResendConfirmModal
